import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { StarPicker } from 'react-star-picker';
import { WebsiteImage } from 'components/TitleDescription';

const TextbasedSocialProof = ({
  background,
  title,
  description,
  ratingScore,
  logoImgs,
  ...otherProps
}) => {
  return (
    <SectionRated background={background} {...otherProps}>
      <div className="section-rated--container">
        <h2 className="section-rated--title">{title}</h2>
        <StarPicker
          name="rating1"
          className="section-rated--star-rating"
          value={ratingScore}
          halfStars
          disabled
          size={52}
          starRendererProps={{
            colorActive: '#0B1A21',
            colorInactive: '#C8D4DA',
          }}
        />
        <h2 className="section-rated--score">{ratingScore} out of 5</h2>
        <p className="section-rated--score-description">{description}</p>
        {logoImgs && logoImgs.length > 0 && (
          <div className="section-rated--logo-container">
            {logoImgs.map(img => {
              return (
                <div className="section-rated--logo" key={img.id}>
                  <WebsiteImage src={img} maxWidth={'100%'} width={'100%'} height={'auto'} />
                </div>
              );
            })}
          </div>
        )}
      </div>
    </SectionRated>
  );
};

TextbasedSocialProof.propTypes = {
  background: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  ratingScore: PropTypes.number,
  logoImgs: PropTypes.array,
};

export default TextbasedSocialProof;

const SectionRated = styled.div`
  background: ${props => props.background};

  .section-rated--container {
    max-width: 745px;
    text-align: center;
    margin: 0 auto;
    padding: 114px 20px 100px;

    .section-rated--title {
      font-size: 49px;
      line-height: 110%;
      text-align: center;
      letter-spacing: -0.04em;
      color: var(--neutral-7);
      margin: 0 auto;
    }

    .section-rated--score {
      font-size: 39px;
      line-height: 110%;
      text-align: center;
      letter-spacing: -0.04em;
      color: var(--neutral-7);
      margin-top: 26px;
    }

    .section-rated--score-description {
      font-size: 20px;
      line-height: 150%;
      text-align: center;
      color: #123654;
      max-width: 399px;
      margin: 31px auto 0;
    }

    .section-rated--logo-container {
      display: flex;
      justify-content: center;
      margin-top: 62px;

      .section-rated--logo {
        margin: auto 0;
        padding: 0 58px;
        width: 100%;
        height: auto;
      }
    }
  }

  @media (max-width: 991px) {
    .section-rated--container {
      .section-rated--title {
        font-size: 36px;
        line-height: 44px;
      }

      .section-rated--score {
        font-size: 36px;
        line-height: 44px;
        margin-top: 30px;
      }

      .section-rated--score-description {
        font-size: 18px;
        line-height: 30px;
        margin: 20px auto 0;
      }

      .section-rated--logo-container {
        margin-top: 38px;

        .section-rated--logo {
          padding: 0 31px;
        }
      }
    }
  }

  @media (max-width: 576px) {
    .section-rated--container {
      padding: 60px 20px;

      .section-rated--title {
        font-size: 32px;
        line-height: 36px;
      }

      .section-rated--score {
        font-size: 32px;
        line-height: 36px;
        margin-top: 24px;
      }

      .section-rated--score-description {
        font-size: 18px;
        line-height: 28px;
        margin: 14px auto 0;
      }

      .section-rated--logo-container {
        margin-top: 30px;
        flex-direction: column;
        align-items: center;

        .section-rated--logo {
          padding: 7px 0px;
          width: 40%;
        }
      }
    }
  }

  .section-rated--star-rating {
    margin-top: 53px;

    .StarPickerButton {
      line-height: 63px;
      cursor: default;

      &.halfStars:nth-child(2n + 1) {
        margin-left: 11px;
      }
      &.halfStars:nth-child(2n) {
        margin-right: 11px;
      }
    }
  }

  @media (max-width: 991px) {
    .section-rated--star-rating {
      margin-top: 45px;

      .StarPickerButton {
        font-size: 38px;
        width: 19px;
        line-height: 47px;

        &.halfStars:nth-child(2n + 1) {
          margin-left: 8px;
        }
        &.halfStars:nth-child(2n) {
          margin-right: 8px;
        }

        & > .StarPickerButton-buttonContent {
          width: 38px;
        }
      }
    }
  }

  @media (max-width: 576px) {
    .section-rated--star-rating {
      margin-top: 20px;

      .StarPickerButton {
        font-size: 26px;
        width: 13px;
        line-height: 32px;

        &.halfStars:nth-child(2n + 1) {
          margin-left: 6px;
        }
        &.halfStars:nth-child(2n) {
          margin-right: 6px;
        }

        & > .StarPickerButton-buttonContent {
          width: 26px;
        }
      }
    }
  }
`;
